import type { SVGProps } from 'react';

const SvgNavigationCustomerHub = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    data-name="Navigation Customer Hub"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="#232121"
      d="M17.53 9.87c0 .85-.69 1.53-1.53 1.53s-1.53-.69-1.53-1.53.69-1.53 1.53-1.53 1.53.69 1.53 1.53ZM13.7 12.93c-.85 0-1.53.69-1.53 1.53s.69 1.53 1.53 1.53h.77v4.6c-.85 0-1.53.69-1.53 1.53s.69 1.53 1.53 1.53h3.07c.85 0 1.53-.69 1.53-1.53s-.69-1.53-1.53-1.53v-7.66h-3.83Z"
    />
    <path
      fill="#232121"
      fillRule="evenodd"
      d="M.67 16C.67 7.54 7.54.67 16 .67S31.33 7.53 31.33 16 24.47 31.33 16 31.33.67 24.46.67 16ZM16 3.74C9.23 3.74 3.74 9.23 3.74 16S9.23 28.26 16 28.26 28.26 22.77 28.26 16 22.77 3.74 16 3.74Z"
    />
  </svg>
);

export default SvgNavigationCustomerHub;
